import React from "react";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";

// A small outlined "reload this data" button that spins while a refresh is in flight.
const RefreshButton = ({ onClick, isRefreshing = false, label = "Refresh", size = 31 }) => (
  <Tooltip title={isRefreshing ? "Refreshing…" : label} placement="top" arrow>
    <span>
      <IconButton
        aria-label={label}
        size="small"
        disabled={isRefreshing}
        onClick={onClick}
        sx={{ width: size, height: size, color: "#555", border: "1px solid #c4c4c4", borderRadius: "4px", backgroundColor: "#fff", "&:hover": { borderColor: "#26890d", color: "#26890d", backgroundColor: "#fff" } }}
      >
        {isRefreshing ? <CircularProgress size={16} sx={{ color: "#26890d" }} /> : <RefreshOutlinedIcon fontSize="small" />}
      </IconButton>
    </span>
  </Tooltip>
);

export default RefreshButton;
